/**
 * Cadre de partie en DUEL (réutilisabilité — Étape 8).
 * Encadre tout l'écran d'une bordure brillante pulsée + badge « ⚔️ DUEL » : on
 * sait en permanence qu'on joue un duel. Volontairement très voyant (vs le
 * bandeau discret d'un parcours). Respecte prefers-reduced-motion.
 */
import { useTranslation } from "react-i18next";
import { Coins } from "lucide-react";

export function DuelFrame({ opponentName, stakeCoins }: { opponentName?: string; stakeCoins?: number }) {
  const { i18n } = useTranslation();
  const fr = i18n.language === "fr";
  return (
    <>
      {/* Bordure lumineuse plein écran (au-dessus de tout, non cliquable). */}
      <div
        className="pointer-events-none fixed inset-0 z-40 rounded-none motion-safe:animate-pulse"
        style={{
          boxShadow: "inset 0 0 0 4px #7B5CF6, inset 0 0 55px rgba(192,66,63,.4), inset 0 0 120px rgba(246,200,71,.18)",
        }}
      />
      {/* Badge DUEL — centré en haut. */}
      <div className="pointer-events-none fixed left-1/2 top-0 z-50 -translate-x-1/2">
        <div
          className="flex items-center gap-2 rounded-b-xl px-4 py-1.5 text-white shadow-lg"
          style={{ backgroundImage: "var(--grad-duel)", boxShadow: "0 6px 18px rgba(192,66,63,.5)" }}
        >
          <span className="font-extrabold tracking-[0.2em] text-xs">⚔️ DUEL</span>
          {opponentName && <span className="text-xs font-semibold opacity-95">vs {opponentName}</span>}
          {stakeCoins ? (
            <span className="flex items-center gap-0.5 text-xs font-bold">
              <Coins className="h-3 w-3" />{stakeCoins}
            </span>
          ) : null}
        </div>
      </div>
      {/* Filet accessibilité : intitulé lisible par lecteur d'écran. */}
      <span className="sr-only">{fr ? "Session jouée en duel" : "Session played as a duel"}</span>
    </>
  );
}
